import { Utils } from '@pacem/pacem-core';
import { ApiParserBase, ApiParameterType } from './types';
export class OpenApi3Parser extends ApiParserBase {
    parse(content, url) {
        let j = content;
        if (typeof j === 'string') {
            j = JSON.parse(j);
        }
        const json = j;
        const endpoints = [];
        const definitions = this._gatherDefinitions(new Map(), json.components.schemas);
        for (let path in json.paths) {
            for (let method in json.paths[path]) {
                const endpoint = json.paths[path][method];
                endpoints.push({
                    path,
                    method: method.toUpperCase(),
                    parameters: this._convertToApiParameters(endpoint.parameters),
                    response: this._tryGetResponse(definitions, endpoint.responses)
                });
            }
        }
        return { endpoints, definitions, baseUrl: url };
    }
    _convertToApiParameters(parameters = []) {
        const output = [];
        for (let p of parameters) {
            const schema = p.schema;
            if ('type' in schema) {
                output.push({ name: p.name, required: p.required, type: this._translateType(schema.type, schema['format']) });
            }
        }
        return output;
    }
    _translateType(type, format) {
        switch (type) {
            case 'number':
            case 'integer':
                return ApiParameterType.Number;
            case 'boolean':
                return ApiParameterType.Boolean;
            case 'string':
                switch (format) {
                    case 'date':
                    case 'date-time':
                        return ApiParameterType.Datetime;
                    case 'byte':
                        return ApiParameterType.Binary;
                    case 'binary':
                        throw `Binary octets not supported.`;
                }
                return ApiParameterType.String;
        }
        return ApiParameterType.String;
    }
    _gatherDefinitions(memoizer, schemas) {
        const retval = {};
        for (let schema in schemas) {
            retval[schema] = this._findDefinition(memoizer, schemas, schema);
        }
        return retval;
    }
    _findDefinition(memoizer, schemas, type) {
        if (memoizer.has(type)) {
            return memoizer.get(type);
        }
        if (type in schemas) {
            // is that enough?
            const retval = schemas[type];
            memoizer.set(type, retval);
            return retval;
        }
        return null;
    }
    _findDefinitionName(definitionHashTag) {
        var pattern = /#\/components\/schemas\/(.+)/;
        var arr = pattern.exec(definitionHashTag);
        if (arr == null || arr.length < 2)
            return definitionHashTag;
        return arr[1];
    }
    _tryGetResponse(definitions, responses) {
        const operation = { responses };
        let ok = operation.responses['200'];
        if (Utils.isNullOrEmpty(ok && ok.content)) {
            return null;
        }
        let schema;
        for (let mime in ok.content) {
            schema = ok.content[mime].schema;
            break;
        }
        let type = 'object', meta, name;
        if ("$ref" in schema) {
            name = this._findDefinitionName(schema.$ref),
                meta = definitions[name];
        }
        else {
            type = schema.type;
            meta = schema;
            if (schema.type === 'array') {
                if ('$ref' in schema.items) {
                    name = this._findDefinitionName(schema.items.$ref);
                    meta = definitions[name];
                }
                else {
                    meta = schema.items;
                }
            }
        }
        return { type, fullType: name, meta };
    }
}
